import { isAnnualTimePeriod } from './pricing-period';

/**
 * Billing periods for coupon copy (matches Coupon::getNumBillingPeriods).
 * Monthly returns raw months; annual returns ceil(months / 12). Zero is allowed.
 */
export function getCouponBillingPeriodCount(
  numMonths: number | undefined,
  timePeriod: string,
): number {
  const months = numMonths ?? 0;
  return isAnnualTimePeriod(timePeriod) ? Math.ceil(months / 12) : months;
}

/**
 * Billing periods for promotional pricing cards — never below 1 when copy is shown.
 */
export function getCouponPromotionalPeriodCount(
  numMonths: number | undefined,
  timePeriod: string,
): number {
  const count = getCouponBillingPeriodCount(numMonths, timePeriod);
  return count > 0 ? count : 1;
}
